





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CField, CustomTableCol, CustomTableItem }
})
export default class testSortQuestionsItem extends Vue {
  @Prop() item!: any;
  @Prop() index!: number;
  @Prop() inProgress!: boolean;
  @Prop() isAllowChangeIndex!: boolean;
  isChanged: boolean = false;
  order: number = 0;

  changeOrder(id: string, index: number) {
    this.isChanged = true;
    this.$emit("changeOrder", { id: id, index: this.index, order: this.order });
  }

  @Watch("index", { immediate: true })
  checkIndex() {
    this.order = this.index + 1;
  }

  @Watch("isChanged")
  checkIsChanged() {
    if (this.isChanged) {
      setTimeout(() => {
        let els = document.querySelector(`.changing`);

        if (els) {
          els?.scrollIntoView({
            block: "center",
            inline: "nearest",
            behavior: "smooth"
          });
        }
        setTimeout(() => {
          this.isChanged = false;
        }, 2000);
      }, 500);
    }
  }
}
